module.exports = __webpack_public_path__ + "static/img/IMG_20160307_163943.a8fe7582.jpg";